import { render } from "./roleSelector.vue?vue&type=template&id=73b5adfd&scoped=true"
import script from "./roleSelector.vue?vue&type=script&lang=js"
export * from "./roleSelector.vue?vue&type=script&lang=js"

import "./roleSelector.vue?vue&type=style&index=0&id=73b5adfd&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b5adfd"]])

export default __exports__